module.exports = __webpack_public_path__ + "static/media/comment2.5690a013.png";